export enum NotificationType {
    MARKET_SUSPENDED = 'altgame.reddog.catalog.v2.market.suspended',
    MARKET_COMMISSION_ENABLED = "altgame.reddog.catalog.v2.market.commission_enabled",
    BALANCE_CHANGED = "altgame.reddog.wallet.v2.balance.changed",
    ORDER_LIMIT_UPDATED = "altgame.reddog.order.v2.limit.updated",
    ORDER_UPDATED = "altgame.reddog.order.v2.updated",
    NOTIFICATION_UPDATED = "altgame.reddog.catalog.v2.notification.updated",
    ORDER_PLACED = "altgame.reddog.order.v2.order_placed",
    ORDER_FAILED = "altgame.reddog.order.v2.order_failed"
}